import {useFluxStore} from 'client/framework';
import sessionStore from 'client/Session/SessionStore';
import {useIsSessionOnlyAnnotationModeAvailable} from 'client/components/PracticeView/Annotations/useIsSessionOnlyAnnotationModeAvailable';

/** `/learn` has no session guard, so teachers, authors and visitors share this view. */
export function useIsSubjectPracticeAnnotationAvailable(): boolean {
  const isSessionOnlyAvailable = useIsSessionOnlyAnnotationModeAvailable();
  const isStudent = useFluxStore(sessionStore, (store) => store.isStudent());

  return isSessionOnlyAvailable && isStudent;
}
